import { useSuspenseQuery } from "@tanstack/react-query"
import { LoginForm } from "app/auth/components/LoginForm"
import { setLoginCsrfCookie } from "app/auth/loginCsrf"
import Layout from "app/core/layouts/Layout"
import { trpc } from "app/trpc"
import type { GetServerSidePropsContext } from "next"
import { useRouter } from "app/core/hooks/useRouter"
import { parseAsString, useQueryState } from "nuqs"
import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"

const LoginPage = () => {
  const router = useRouter()
  const [next] = useQueryState("next", parseAsString)
  const posthog = usePostHog()
  const { data: currentUser } = useSuspenseQuery(
    trpc.users.getCurrentUser.queryOptions()
  )

  useEffect(() => {
    if (currentUser) {
      router.push(next ? decodeURIComponent(next) : "/")
    }
  }, [currentUser, next, router])

  return (
    <div>
      <LoginForm
        onSuccess={async (result) => {
          const user = result?.user
          if (!user) {
            return router.push(
              next ? `/login?next=${encodeURIComponent(next)}` : "/login"
            )
          }

          // await queryClient.invalidateQueries()

          if (user.organizationUsers && user.organizationUsers.length === 1) {
            posthog.group(
              "organization",
              user.organizationUsers[0].organizationId.toString(),
              {
                organizationName:
                  user.organizationUsers[0].organization.displayTitle,
              }
            )
            posthog.identify(user.id.toString())
          } else if (
            !user.organizationUsers ||
            user.organizationUsers.length === 0
          ) {
            posthog.identify(user.id.toString(), {
              role: user.role,
            })
          }

          if (user.role === "ADMIN") {
            router.push("/admin/Lesson")
          } else if (
            user.organizationUsers?.[0]?.onboardingType === "ONBOARDING"
          ) {
            router.push(
              router.query.next
                ? `/onboarding/welkom?next=${encodeURIComponent(router.query.next as string)}`
                : "/onboarding/welkom"
            )
          } else if (
            user.organizationUsers &&
            user.organizationUsers[0].onboardingType === "SCHOOLYEAR"
          ) {
            router.push(
              router.query.next
                ? `/reboarding/welkom?next=${encodeURIComponent(router.query.next as string)}`
                : "/reboarding/welkom"
            )
          } else {
            const next = router.query.next
              ? decodeURIComponent(router.query.next as string)
              : "/"
            router.push(next)
          }
        }}
      />
    </div>
  )
}

LoginPage.redirectAuthenticatedTo = "/"
LoginPage.getLayout = (page) => <Layout title="Log In">{page}</Layout>

export async function getServerSideProps(context: GetServerSidePropsContext) {
  setLoginCsrfCookie(context.res)
  return { props: {} }
}

export default LoginPage
